/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VolunteerStatsDto } from '../../models/volunteer-stats-dto';

export interface AdminStatsControllerGetVolunteerStats$Params {
}

export function adminStatsControllerGetVolunteerStats(http: HttpClient, rootUrl: string, params?: AdminStatsControllerGetVolunteerStats$Params, context?: HttpContext): Observable<StrictHttpResponse<VolunteerStatsDto>> {
  const rb = new RequestBuilder(rootUrl, adminStatsControllerGetVolunteerStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VolunteerStatsDto>;
    })
  );
}

adminStatsControllerGetVolunteerStats.PATH = '/admin-stats/volunteers';
